export type TEnvironmentLabel = 'PROD' | 'HML' | 'LOCAL';

export const getEnvironmentLabel = (): TEnvironmentLabel => {
  const hubBaseUrl = import.meta.env.VITE_HUB_BASE_URL ?? '';
  if (hubBaseUrl.includes('localhost')) return 'LOCAL';
  if (hubBaseUrl.includes('hml') || hubBaseUrl.includes('dev')) return 'HML';
  return 'PROD';
};
